import axios from "axios";
import { axiosInstance } from "../configuration/apiFunction";
axios.defaults.baseURL = "/api";

const api = {
  get: (url, params = {}) => axiosInstance.get(url, { params }),
  post: (url, data = {}, params = {}) =>
    axiosInstance.post(url, data, { params }),
  put: (url, data = {}) => axiosInstance.put(url, data),
  delete: (url) => axiosInstance.delete(url),
};

export default api;

export async function CustomAxios(url, method, body, headers) {
  const token = localStorage.getItem("authToken");
  let httpHeaders = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Methods": "GET, POST",
  };
  if (token) {
    httpHeaders["Authorization"] = `Bearer ${token}`;
  }
  if (headers) {
    httpHeaders = { ...httpHeaders, ...headers };
  }
  try {
    return await axios({
      url: `${url}`,
      method: method,
      headers: httpHeaders,
      data: body,
    });
  } catch (error) {
    // If 401, attempt token refresh and retry once
    if (error.response?.status === 401) {
      const refreshToken = localStorage.getItem("refresh_token");
      if (refreshToken) {
        try {
          const { data } = await axios.post("/api/refresh-token", {
            refresh_token: refreshToken,
          });
          localStorage.setItem("authToken", data.access_token);
          httpHeaders["Authorization"] = `Bearer ${data.access_token}`;
          return await axios({
            url: `${url}`,
            method: method,
            headers: httpHeaders,
            data: body,
          });
        } catch (refreshError) {
          localStorage.removeItem("authToken");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("isAuthenticated");
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      } else {
        localStorage.removeItem("authToken");
        localStorage.removeItem("isAuthenticated");
        window.location.href = "/login";
      }
    }
    throw error;
  }
}
